import useRequest from '@/websdk/utils/request';
export default (function (params) {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/maintain/rec/mold/detail`,
    name: 'MOLD_MAINTAIN_RECOVER_DETAIL_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
